/**
 * Thrown when a component with an invalid name is added to the application.
 */
export default class InvalidComponentNameError extends Error {

    /**
     * Creates a new instance of InvalidComponentNameError
     * @param {string} componentName The name of the component that was invalid
     */
    constructor(componentName) {
        super(`${componentName} is not a valid name for a component.`);

        this.componentName = componentName;
    }
}



// WEBPACK FOOTER //
// ./source/framework/errors/InvalidComponentNameError.js